const LIST_TYPES = {
  DEFAULT: 'ul',
  ORDERED: 'ol'
};
const LIST_VARIANTS = {
  CHECK: 'check',
  PLAIN: 'plain',
  SIMPLE: 'simple',
  STANDARD: 'standard'
};

export { LIST_TYPES, LIST_VARIANTS };
